import app from "../firebase";
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions(app, "us-central1");

const callParasutAction = async (parasutAction, data = {}) => {
  const callable = httpsCallable(functions, "createUser");
  return (await callable({ parasutAction, ...data })).data;
};

export const getParasutAuthorizationUrl = async () => {
  return callParasutAction("authorizationUrl");
};

export const connectParasutWithCode = async ({ code, companyId = "" }) => {
  return callParasutAction("connectWithCode", { code, companyId });
};

export const getParasutConnectionStatus = async () => {
  return callParasutAction("status");
};

export const syncParasutContacts = async ({ companyId = "" } = {}) => {
  return callParasutAction("syncContacts", { companyId });
};

export const listParasutContacts = async () => {
  return callParasutAction("listContacts");
};
